import { render, staticRenderFns } from "./InputReplyForReceiveRequestTab.vue?vue&type=template&id=2e231849&scoped=true&lang=pug"
import script from "./InputReplyForReceiveRequestTab.vue?vue&type=script&lang=ts"
export * from "./InputReplyForReceiveRequestTab.vue?vue&type=script&lang=ts"
import style0 from "./InputReplyForReceiveRequestTab.vue?vue&type=style&index=0&id=2e231849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e231849",
  null
  
)

export default component.exports